import styled from "styled-components";

const OverviewSection = styled.section`
  padding: 80px 0;
  background-color: #fff;

  div.hover {
    > img:nth-child(1) {
      transition: transform 0.6s linear, opacity 0.6s linear;
      opacity: 0.3;
      margin-right: 40px;
    }
    > div:nth-child(2) {
      transition: opacity 0.6s linear;
      opacity: 0.3;
    }
  }
  div.line > div:nth-child(1) {
    transition: transform 2s linear ;
    transform: translate(300%, -50%);
  }
  &:hover {
    div.hover {
      > div:nth-child(3) {
        transform: translate(-40px, -40px);
      }
      > img:nth-child(1) {
        transform: translate(-40px, 0);
        opacity: 1;
      }
      > div:nth-child(2) {
        opacity: 1;
      }
    }

    div.line > div:nth-child(1) {
      transform: translate(0%, -50%);
    }
  }
`;

const OverviewContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
`;

const OverviewImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
  min-width: 350px;
  min-height: 407px;
  user-select: none;
  @media (max-width: 900px) {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

const OverviewImagePlaceholder = styled.div`
  width: 350px;
  height: 407px;
  border-radius: 0;
  background-image: url(/assets/about/house.png);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  z-index: 2;
  transition: transform 0.3s linear;
  cursor: pointer;
`;

const OverviewImageBlueBlock = styled.div`
  width: 350px;
  height: 407px;
  border-radius: 0;
  background: #2640ed;
  position: absolute;
  z-index: 1;
`;

const OverviewContentContainer = styled.div`
  flex: 1;
  min-width: 350px;
`;

const OverviewTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
  text-align: center;
`;

const OverviewSubTitle = styled.div`
  font-size: 1.1rem;
  color: #888;
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: 1px;
`;

const OverviewContent = styled.p`
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  text-align: justify;
`;

const OverviewLineWrap = styled.div`
  margin-top: 32px;
  position: relative;
`;

const OverviewLineSlider = styled.div`
  width: 78px;
  height: 7px;
  background: #2640ed;
  position: absolute;
  left: 0;
  z-index: 1;
`;

const OverviewLine = styled.div`
  width: 317px;
  height: 1px;
  background: #e6e8f0;
  position: absolute;
  left: 0;
`;

const OverviewSmallTitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  background: #fff;
`;

const OverviewSmallTitleBar = styled.div`
  width: 5px;
  height: 22px;
  background: #2640ed;
  border-radius: 2px;
  margin-right: 12px;
`;

const OverviewSmallTitle = styled.div`
  font-size: 1.18rem;
  color: #222;
  font-weight: 600;
`;
export default function OverviewSectionComponent() {
  return (
    <OverviewSection>
      <OverviewTitle>企业概况</OverviewTitle>
      <OverviewSubTitle>Corporate Overview</OverviewSubTitle>
      <OverviewContainer>
        <OverviewContentContainer>
          <OverviewSmallTitleRow>
            <OverviewSmallTitleBar />
            <OverviewSmallTitle>浙江京保科技有限公司</OverviewSmallTitle>
          </OverviewSmallTitleRow>
          <OverviewContent>
            浙江京保科技是一家专注于电子保函领域的金融科技解决方案提供商。致力于互联网“金融+科技”手段，打造金融领域值得信赖可以提供各类工程保函服务的新型金融服务平台。秉持着高效、稳定、创新的三个原则来不断完善现有平台功能，同时引进银行、保险及担保公司等优秀的供应商作为合作伙伴，为建筑施工与贸易类企业提供流程更快捷、性价比更高、可选择范围更广的出函服务。
            <br />
            <br />
            目前率先为温州市金茂融资担保有限公司提供技术开发与服务支持，使其成功在9省40余县市区各交易平台上线，业务运行良好。同时在与现有的海南鑫汇、长春众升、和田玖信等融资担保及平安银行合作以外，也在积极寻找更多的合作可能，非常欢迎各地的优秀伙伴莅临考察，促进双方共赢。
          </OverviewContent>
          <OverviewLineWrap className="line">
            <OverviewLineSlider />
            <OverviewLine />
          </OverviewLineWrap>
        </OverviewContentContainer>
        <OverviewImageContainer className="hover">
          <img src="/assets/product/aus.png" />
          <OverviewImageBlueBlock />
          <OverviewImagePlaceholder />
        </OverviewImageContainer>
      </OverviewContainer>
    </OverviewSection>
  );
}
